export const common = {
  download: 'Download',
  loading: 'Loading...',
  save: 'Save',
  cancel: 'Cancel',
  edit: 'Edit',
  delete: 'Delete',
  create: 'Create',
  search: 'Search...',
  logout: 'Logout',
  close: 'Close',
  noData: 'No data to display',
  error: 'Error',
  reload: 'Reload',
  select_language: 'Select language',
  dateFilter: 'Filter by Date',
  showing: 'Showing {{count}} entries',
  exportExcel: 'Export to Excel',
  inDevelopment: 'Under Development',
  whatsNew: 'Latest Improvements',
  version: 'Version',
  systemUnderDevelopment: 'The system is continuously under development',
  actions: {
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    create: 'Create',
    view: 'View',
    close: 'Close',
    share: 'Share'
  },
  back: 'Back',
  next: 'Next',
  profile: {
    title: 'Profile Settings',
    personalInfo: 'Personal Information',
    fullName: 'Full Name',
    email: 'Email Address',
    phone: 'Phone Number',
    organization: 'Organization Details',
    organizationName: 'Organization Name',
    taxNumber: 'Tax Number',
    registrationNumber: 'Registration Number',
    organizationStatus: 'Organization Status',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    updatePassword: 'Update Password'
  },
  messages: {
    confirmDelete: 'Are you sure you want to delete this item?',
    deleteWarning: 'This action cannot be undone. The item will be permanently deleted.',
    profile: {
      updateSuccess: 'Profile updated successfully',
      updateError: 'Error updating profile',
      passwordMismatch: 'Passwords do not match',
      passwordChangeSuccess: 'Password changed successfully',
      passwordChangeError: 'Error changing password'
    },
    linkCopied: 'Link copied to clipboard',
    shareError: 'Error sharing link',
    authContext: {
      error: 'Error loading user data',
      signInSuccess: 'Sign in successful!',
      signInError: 'Sign in failed',
      signOutSuccess: 'Sign out successful!',
      signOutError: 'Sign out failed',
      invalidCredentials: 'Invalid email or password',
      userDisabled: 'This user account is disabled',
      tooManyRequests: 'Too many failed attempts. Please try again later'
    },
    customer: {
      failedToLoad: 'Error loading customers',
      createdSuccess: 'Customer created successfully',
      createdError: 'Error creating customer',
      updatedSuccess: 'Customer updated successfully',
      updatedError: 'Error updating customer',
      deletedSuccess: 'Customer deleted successfully',
      deletedError: 'Error deleting customer',

      customerStatusUpdated: 'Customer status updated: ',
      customerStatusUpdateFailed: 'Error updating customer status'
    },
    quotation: {
      createSuccess: 'Quotation created successfully',
      createError: 'Error creating quotation',
      offerStatusUpdated: 'Quotation status updated: ',
      offerStatusUpdateFailed: 'Error updating quotation status',
      updateStatus: "Click to modify status"
    },
    organization: {
      emailNotFound: 'No user found with this email',
      userAlreadyExists: 'This user is already a member of this organization',
      userAdded: 'User added successfully',
      userInvited: 'User invited successfully',
      userAddError: 'Error adding user',
      userRemoved: 'User removed successfully',
      userRemoveError: 'Error removing user',

      createdSuccess: 'Organization created successfully',
      createdError: 'Error creating organization',
      updateSuccess: 'Organization updated successfully',
      updateError: 'Error updating organization',
      deleteSuccess: 'Organization deleted successfully',
      deleteError: 'Error deleting organization',

      logoUploadSuccess: 'Logo uploaded successfully',
      logoUploadError: 'Error uploading logo',
      logoDeleteSuccess: 'Logo removed successfully',
      logoDeleteError: 'Error removing logo',
    },
    copyError: 'Error copying link',
    documentGenerationStarted: 'Document generation started:',
    alerts: {
      noActiveAlerts: 'No active alerts currently',
      systemHealthy: 'All system components are functioning properly',
      criticalAlerts: 'critical',
      warningAlerts: 'warnings',
      closeAll: 'Close All',
      closeAlert: 'Close Alert',
      levels: {
        critical: 'CRITICAL',
        error: 'ERROR',
        warning: 'WARNING',
        info: 'INFO'
      },
      messages: {
        providerError: 'Provider {{provider}} processing error',
        authenticationFailed: 'SFTP authentication error - password verification required',
        connectionError: 'Connection error - network or server issue',
        unknownError: 'Unknown {{provider}} processing error',
        errorWithTime: '{{details}} ({{minutes}} minutes ago)',
        highMemoryUsage: 'High memory usage detected',
        memoryDetails: 'Peak memory: {{maxMemory}} MB ({{processCount}} processes affected)',
        staleData: '{{provider}} data is stale',
        staleDataDetails: 'Last update: {{days}} days ago',
        staleDataWarning: 'Last update: {{days}} days ago - Automatic synchronization required',
        slowProcessing: '{{provider}} slow processing',
        slowProcessingDetails: 'Processing time: {{duration}} minutes ({{records}} records)',
        poorDataQuality: '{{provider}} poor data quality',
        qualityDetails: 'Data completeness: {{completeness}}% ({{invalidMeasurements}} invalid measurements)',
        statisticsSummary: '{{count}} {{type}}'
      }
    },
    monitoring: {
      autoRefresh: 'Auto-refresh',
      refreshNow: 'Refresh Now'
    }
  },
  placeholders: {
    selectOrg: 'Select organization...',
    selectCustomer: 'Select customer...',
    selectProduct: 'Select product...',
    selectQuotation: 'Select quotation...',
    notes: 'Additional notes for the quotation...',
    itemNotes: 'Note for this item...',
    quotationNotes: 'General notes for the quotation...',
    email: 'Email address...',
    unitPlaceholder: 'e.g.: piece, hour, day',
    deals: "Select deal..."
  },
  page: {
    notFound: 'Page not found',
    returnToDashboard: 'Return to Dashboard'
  },
  settings: {
    title: 'Settings',
  },
  pagination: {
    showing: 'Showing',
    itemsPerPage: 'items/page',
    of: 'of',
    to: 'to',
    results: 'results'
  },
  accept: 'Accept',
  deny: 'Deny',
  add: 'Add',
  remove: 'Remove',
  uploading: 'Uploading...',
  modifiedBy: 'Modified by',
  submit: 'Submit',
  submitting: 'Submitting...',
  onboarding: {
    skip: 'Skip',
    next: 'Next',
    back: 'Back',
    finish: 'Finish'
  }
}